var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('new-addresource',{attrs:{"onlyupload":true},on:{"ouput-value":_vm.ceshi}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }